(function () {
    function r(e, n, t) {
        function o(i, f) {
            if (!n[i]) {
                if (!e[i]) {
                    var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
                }var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
                    var n = e[i][1][r];return o(n || r);
                }, p, p.exports, r, e, n, t);
            }return n[i].exports;
        }for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
            o(t[i]);
        }return o;
    }return r;
})()({ 1: [function (require, module, exports) {
        var initHeaderDropdown = function initHeaderDropdown(selector, toggleSelector) {
            var dropdown = document.querySelector(selector);

            if (!dropdown) {
                return;
            }

            var toggle = dropdown.querySelector(toggleSelector);

            if (!toggle) {
                return;
            }

            var closeDropdown = function closeDropdown() {
                dropdown.classList.remove('is-open');
                toggle.setAttribute('aria-expanded', 'false');
            };

            toggle.addEventListener('click', function (event) {
                event.preventDefault();
                event.stopPropagation();

                var isOpen = dropdown.classList.toggle('is-open');
                toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            });

            document.addEventListener('click', function (event) {
                if (!dropdown.contains(event.target)) {
                    closeDropdown();
                }
            });

            document.addEventListener('keydown', function (event) {
                if (event.key === 'Escape') {
                    closeDropdown();
                }
            });

            return dropdown;
        };

        document.addEventListener('DOMContentLoaded', function () {
            var currency = initHeaderDropdown('.navbar-header-currency', '.navbar-header-currency__toggle');

            initHeaderDropdown('.navbar-header-language', '.navbar-header-language__toggle');

            if (!currency) {
                return;
            }

            currency.querySelectorAll('.js-set-currency').forEach(function (item) {
                item.addEventListener('click', function (event) {
                    event.preventDefault();
                    event.stopPropagation();

                    if (window.utils && item.dataset.value) {
                        window.utils.setCurrency(item.dataset.value);
                    }
                });
            });
        });
    }, {}] }, {}, [1]);